export default {
    methods: {
        getTicketReferenceColorStyles (ticket, element) {
            if (ticket.status === "closed") {
                return element === "text" ? "text-gray-400 font-normal" : "bg-gray-400";
            } else {
                switch (ticket.priority) {
                    case "low":
                        return element === "text" ? "text-green-600" : "bg-green-600";
                    case "medium":
                        return element === "text" ? "text-indigo-600" : "bg-indigo-600";
                    case "high":
                        return element === "text" ? "text-red-600" : "bg-red-600";
                    default:
                        return element === "text" ? "text-gray-400" : "bg-gray-400";
                }
            }
        },

        getTransactionRequestStatusColor (status) {
            switch (status) {
                case "billed":
                    return "bg-green-100 text-green-600";
                case "rejected":
                    return "bg-red-100 text-red-600";
                default:
                    return "bg-gray-100 text-gray-600";
            }
        },
    }
};
